import setupInteractionTrigger from './modules/muiManager';
import { initializeHeroCarousel, initializeHeroCarouselHome, initializeGalleryOverlay } from './modules/glideSetup';
import { setupAccordions } from './modules/accordionSetup';
import { setupAgendaOption } from './modules/dayAgendaOptions';
import { setupNavigationObserver, buildNavigationList } from './modules/navigationObserver';
import { setupDetailListToggle, collapseContent } from './modules/collapseContent';
import { setupMenuToggle } from './modules/menuHandler';
import { setupScrollIndicator } from './modules/navigationScrollIndicator';

document.addEventListener('DOMContentLoaded', () => {
  setupAccordions();
  buildNavigationList();
  setupDetailListToggle();
  setupAgendaOption();
  setupMenuToggle();
  setupScrollIndicator();
});

window.onload = function() {
  setupNavigationObserver();
};

const initializationFunctions = [
  initializeHeroCarousel,
  initializeHeroCarouselHome,
  initializeGalleryOverlay,
  collapseContent
];

setupInteractionTrigger(initializationFunctions);
